import React, {
  createContext,
  ElementRef,
  ReactComponentElement,
  useRef,
  useState
} from "react";
import { createPortal } from "react-dom";

import { useHideUpdateToastOnMobile } from "features/app/hooks/useHideUpdateToastWhileMounted";

const ModalNodeContext = createContext<any>(null);

type ChildrenProps = {
  children: ReactComponentElement<any, any> | ReactComponentElement<any, any>[];
};

function ModalNodeProvider({ children }: ChildrenProps) {
  const modalNode = useRef<ElementRef<any>>(null);
  const [refProvided, setRefProvided] = useState(false);

  const setRef = (element: any) => {
    if (refProvided) {
      return;
    }

    modalNode.current = element;

    setRefProvided(true);
  };

  return (
    <>
      <ModalNodeContext.Provider value={refProvided ? modalNode.current : null}>
        {children}
      </ModalNodeContext.Provider>
      <div ref={setRef} />
    </>
  );
}

type ConsumerProps = {
  children: (arg0: ElementRef<any>) => ReactComponentElement<any, any> | null;
};

function ModalNodeConsumer({ children }: ConsumerProps) {
  return (
    <ModalNodeContext.Consumer>
      {modalNode => children(modalNode)}
    </ModalNodeContext.Consumer>
  );
}

function ModalPortal({ children }: ChildrenProps) {
  useHideUpdateToastOnMobile();
  return (
    <ModalNodeConsumer>
      {modalNode =>
        modalNode ? createPortal(children, modalNode as any) : null
      }
    </ModalNodeConsumer>
  );
}

export { ModalNodeProvider, ModalNodeConsumer, ModalPortal };
